import { create } from "zustand";

type volumeStoreType = {
  volume: number;
  setVolume: (number: number) => void;
  setVolumeXR: (number: number) => void;
};
export const useVolumeStore = create<volumeStoreType>()((set) => ({
  volume: 1,
  setVolumeXR: (vol: number) => {
    if (vol < 0.05) set({ volume: 0 });
    else if (vol > 0.95) set({ volume: 1 });
    else set({ volume: vol });
  },
  setVolume: (vol: number) => {
    set({ volume: vol });
  },
}));

type zoomStore = {
  zoom: number;
  setZoom: (e: React.WheelEvent) => void;
};

export const useZoomStore = create<zoomStore>()((set, get) => ({
  zoom: 50,
  setZoom: (e: React.WheelEvent) => {
    let zoom = get().zoom;

    if (Math.sign(e.deltaY) === -1) {
      if (zoom <= 15) return;
      else set({ zoom: zoom - 4 });
    } else {
      if (zoom >= 90) set({ zoom: 90 });
      else set({ zoom: zoom + 4 });
    }
  },
}));
